import React, { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { TextField, Typography } from '@mui/material';

import { StyledAddToDoItemWrap, StyledAddToDoTemTextFieldWrap } from './styled';

interface PropsType {
	label?: string;
	onSave: (name: string) => void;
}

function AddToDoItem({ label = 'To do', onSave }: PropsType) {
	const [isEditing, setIsEdit] = useState(false);
	const [title, setTitle] = useState('');

	const handleSave = () => {
		if (title.trim()) {
			onSave(title);
			setTitle('');
		}
		setIsEdit(false);
	};

	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleSave();
		}
	};

	return (
		// eslint-disable-next-line
		<>
			{isEditing ? (
				<StyledAddToDoTemTextFieldWrap>
					<TextField
						value={title}
						onChange={(e) => setTitle(e.target.value)}
						onBlur={handleSave}
						autoFocus
						fullWidth
						type="text"
						onKeyDown={handleKeyDown}
					/>
				</StyledAddToDoTemTextFieldWrap>
			) : (
				<StyledAddToDoItemWrap onClick={() => setIsEdit(true)}>
					<AddIcon color="primary" />
					<Typography variant="body1" color="#999999">
						{label}
					</Typography>
				</StyledAddToDoItemWrap>
			)}
		</>
	);
}

export default AddToDoItem;
